/**
 * Меню «Создать ▾» в шапке Activity-чата.
 *
 * Пункты меню приходят из реестра расширений Activity
 * (`registerActivityHeaderAction`): каждый модуль-владелец декларирует свои
 * действия с фильтром `isAvailable(entityType)`. Если для текущего треда нет
 * ни одного доступного действия — кнопка не рендерится.
 */
import { Button, Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import {
  activityUiHelpers,
  getActivityHeaderActions,
} from '@ayocore/activity/client/extensions';

type Props = {
  entityType: string;
  entityUuid: string;
};

/**
 * Возвращает меню действий «+» для шапки активити-чата. Скрывается, если
 * для текущего треда нет ни одного доступного действия.
 */
export function ActivityHeaderActionsMenu({ entityType, entityUuid }: Props) {
  const availableItems = getActivityHeaderActions(entityType);
  if (availableItems.length === 0) return null;

  return (
    <Menu position='bottom-end' withArrow withinPortal trigger='click-hover'>
      <Menu.Target>
        <Button
          size='xs'
          variant='light'
          rightSection={<IconChevronDown size={14} />}
          aria-label='Создать'
        >
          Создать
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {availableItems.map(item => (
          <Menu.Item
            key={item.id}
            onClick={() => {
              void item.onSelect({ entityType, entityUuid }, activityUiHelpers);
            }}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
